import { createApp } from "vue";
import App from "./App.vue";
import "./assets/tailwind.css";
import router from "./router";
import store from "./store";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebook, faGoogle } from '@fortawesome/free-brands-svg-icons'
import { faAdjust, faAngleDoubleLeft, faAngleDoubleRight, faTimesCircle, faSignOutAlt, faSync, faExternalLinkSquareAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueApexCharts from "vue3-apexcharts";
import VTooltip from 'v-tooltip'
import './registerServiceWorker'
import { v4 as uuidv4 } from 'uuid';
import './assets/tailwind.css'

if (!localStorage.getItem('_devK')){
  localStorage.setItem('_devK', uuidv4())
}


library.add(faFacebook)
library.add(faGoogle)
library.add(faAdjust)
library.add(faAngleDoubleLeft)
library.add(faAngleDoubleRight)
library.add(faTimesCircle)
library.add(faSignOutAlt)
library.add(faSync)
library.add(faExternalLinkSquareAlt)

// On page load or when changing themes, best to add inline in `head` to avoid FOUC
if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
  document.documentElement.classList.add('dark')
  
} else {
  document.documentElement.classList.remove('dark')
}





let app = createApp(App)
  .use(store)
  .use(router)
  .use(VueApexCharts)
  .use(VTooltip)

app.component('font-awesome-icon', FontAwesomeIcon)
app.mount('#app')